/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { contribuyenteToString } from 'utils/padronesToString';
import { InputSearchPro } from 'components/InputSearch';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { dataTypesEnum, padronesEnum } from '../enums';

const fieldsInfo = {
  _giros_de_modulos: {
    id: '_giros_de_modulos',
    nombre_en_la_bd: '_giros_de_modulos',
    tipo_de_dato_del_campo: dataTypesEnum.TEXT,
  },
};

const tabs = [
  {
    title: 'Información General',
    fields: [
      'clave',
      'mercado_de_modulo',
      'zona_de_modulo',
      'contribuyente',
      'numero_de_puesto',
      'numero_de_locales',
      'metros_de_largo',
      'metros_de_ancho',
      'superficie',
      'observaciones',
    ],
  },
  process.env.REACT_APP_ENV_NAME === 'oaxaca' && {
    title: '',
    fields: ['_giros_de_modulos'],
  },
].filter((e) => e);

const configs = {
  clave: {
    formItemProps: {
      label: 'Objeto cuenta',
      required: true,
    },
  },
  mercado_de_modulo: {
    formItemProps: {
      label: 'Mercado',
    },
  },
  zona_de_modulo: {
    formItemProps: {
      label: 'Zona',
    },
  },
  numero_de_puesto: {
    formItemProps: {
      label: 'Número de puesto',
    },
  },
  numero_de_locales: {
    formItemProps: {
      label: 'Número de locales',
    },
  },
  metros_de_largo: {
    formItemProps: {
      label: 'Largo',
    },
  },
  metros_de_ancho: {
    formItemProps: {
      label: 'Ancho',
    },
  },
  superficie: {
    formItemProps: {
      label: 'Superficie en m2',
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
    },
    colProps: { md: 16 },
    controlProps: {
      autoSize: { minRows: 3, maxRows: 3 },
    },
  },
  _giros_de_modulos: {
    formItemProps: {
      label: 'Giros',
    },
    controlProps: {
      autoSize: { minRows: 5, maxRows: 5 },
      disabled: true,
    },
    colProps: { md: 24 },
  },
  contribuyente: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.CONTRIBUYENTE, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Contribuyente',
    tooltip: 'Búsqueda por clave, correo electrónico, nombre completo del contribuyente',
    resultProps: {
      name: 'contribuyente',
      label: 'Contribuyente',
      render: (contribuyente) => contribuyenteToString(contribuyente),
      breakPoints: { md: 16 },
    },
    breakPoints: { md: 16 },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
